//variables of strings that can be used and call to be called to change state through reducer

export const SEARCH_USERS = 'SEARCH_USERS';
export const GET_USER = 'GET_USER';
export const CLEAR_USERS = 'CLEAR_USERS';
export const GET_REPOS = 'GET_REPOS';
export const GET_LOADING = 'GET_LOADING';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERTS = 'REMOVE ALERTS';